import API, {
    APIError, APIResponse, APIResult, Nullable,
} from 'app/api/NewAPI';
import {
    APIAllProductsResponse,
    APICart, APIFinanceInfo, APIGameData,
    APIProduct, APIProductTypes, APIProfession, APIRequestBuySpecialProduct,
    APIRequestSignIn,
    APIRequestSignUp, APISpecialProduct,
    APITransactionInfo,
    APITransactionItem,
    APIUpdateCartRequest,
    APIUser, APIWalletHistory, APIWalletHistoryItem, IAllSum,
} from 'app/api/APITypes';

class SberAPI extends API {
    private user: Nullable<APIUser> = null;

    public get User() {
        return this.user;
    }

    protected Set<T>(key: string, value: T): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    protected Get<T>(key: string): Nullable<T> {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) as T : null;
    }

    public async Ping(): Promise<boolean> {
        const response = await this.ExecuteRoute({
            route: '/ping',
            method: 'GET',
            secure: false,
            contentType: 'application/json',
        });
        return !(response instanceof APIError);
    }

    public async Init(): Promise<'logged_in' | 'not_logged_in'> {
        const loginState = this.HasToken;
        try {
            //           if(serverState){
            if (loginState) {
                const response = await this.GetUser();
                if (response instanceof APIError) {
                    return 'not_logged_in';
                }
            }
            return 'logged_in';

            //           } else {
            //                const response = await this.GetUser()
            //                if(response instanceof APIError){
            //                    return 'not_logged_in'
            //                } else {
            //                    return 'logged_in'
            //                }
            // }
        } catch (error: unknown) {
            return 'not_logged_in';
        }
    }

    public async GetUser(): Promise<APIUser> {
        const response = await this.ExecuteRoute<null, APIUser>({
            route: '/user/get',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, null);
        if (response instanceof APIError) {
            throw response;
        } else {
            this.user = response.data;
            this.SetLoginState('logged_in');
        }
        return response.data;
    }

    public async EditUser(request: Partial<APIUser>): Promise<APIUser> {
        const response = await this.ExecuteRoute<typeof request, APIUser>({
            route: '/user/edit',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);

        if (response instanceof APIError) {
            throw response;
        } else {
            this.user = response.data;
            return response.data;
        }
    }

    // public async SignIn(request: APIRequestSignIn): Promise<void> {
    //     const response = await this.ExecuteRoute<typeof request, {token: string}>({
    //         route: '/auth/signin',
    //         method: 'POST',
    //         secure: false,
    //         contentType: 'application/json',
    //     }, request);
    //     if (response instanceof APIError) {
    //         throw response;
    //     } else {
    //         this.SetToken(response.data.token);
    //     }
    // }

    public async SignUp(request: APIRequestSignUp): Promise<any> {
        const response = await this.ExecuteRoute<typeof request, {token: string}>({
            route: '/auth/signup',
            method: 'POST',
            secure: false,

            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        } else {
            this.SetToken(response.data.token);
            this.SetLoginState('logged_in');
        }

        return response;
    }

    public async SignIn(request: APIRequestSignUp): Promise<any> {
        const response = await this.ExecuteRoute<typeof request, {token: string}>({
            route: '/auth/signin',
            method: 'POST',
            secure: false,

            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        } else {
            this.SetToken(response.data.token);
            this.SetLoginState('logged_in');
        }

        return response;
    }

    public async PasswordResetInit(request: {email: string}): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/auth/password-reset-init',
            method: 'POST',
            secure: false,
            contentType: 'application/json',
        }, request);

        if (response instanceof APIError) {
            throw response;
        }
    }

    public async PasswordReset(request: {token: string, password: string, password_repeat: string}): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/auth/password-reset',
            method: 'POST',
            secure: false,
            contentType: 'application/json',
        }, request);
        sessionStorage.removeItem(this.config.tokenCacheKey);
        this.SetLoginState('not_logged_in');
        if (response instanceof APIError) {
            throw response;
        }
    }

    // кошелек и инвестиции
    public async GetUserMoney(request: 'wallet' | 'moneybox' | 'deposit' | 'nsj'): Promise<APITransactionInfo> {
        const response = await this.ExecuteRoute<null, APITransactionInfo>({
            route: `/user/${request}`,
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }

        return response.data;
    }

    public async GetProducts(request: {filter?: APIProductTypes}): Promise<APIAllProductsResponse> {
        const response = await this.ExecuteRoute<typeof request, APIAllProductsResponse>({
            route: '/shop/products',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async GetCart(): Promise<APICart> {
        const response = await this.ExecuteRoute<null, APICart>({
            route: '/shop/cart',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async GetFinanceInfo(): Promise<APIFinanceInfo> {
        const response = await this.ExecuteRoute<null, APIFinanceInfo>({
            route: '/finance/info',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async CancelAll(): Promise<void> {
        const response = await this.ExecuteRoute({
            route: '/finance/cancel-all',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async UpdateCart(request: APIUpdateCartRequest): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/shop/update-cart',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async BuyCart(): Promise<void> {
        const response = await this.ExecuteRoute({
            route: '/shop/buy-cart',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
    }

    // TODO
    public async DeleteCart(request: { productId: number }): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/shop/delete-product',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async GetSpecialProducts(): Promise<APISpecialProduct[]> {
        const response = await this.ExecuteRoute<null, APISpecialProduct[]>({
            route: '/finance/list',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async BuySpecialProduct(request: APIRequestBuySpecialProduct): Promise<{error?: string}> {
        const response = await this.ExecuteRoute<typeof request, {error?: string}>({
            route: '/finance/buy',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async GetAllSum(): Promise<IAllSum> {
        const response = await this.ExecuteRoute<null, IAllSum>({
            route: '/user/get-sum-all',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async WalletHistory(): Promise<APIWalletHistory> {
        const response = await this.ExecuteRoute<null, APIWalletHistory>({
            route: '/user/wallet',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        // // TODO This is bad. Refactor it
        // let res: (APIWalletHistoryItem | APIWalletHistoryItem[])[] = [];
        // if (response.data.group_keys) {
        //     for (const group of response.data.group_keys) {
        //         for (let lvl = 1; lvl < 5; lvl++) {
        //             const groupedByCategoryAndLevel = response.data.history.filter((value) => value.group === group && value.level === lvl);
        //             if(groupedByCategoryAndLevel.length)
        //                 res = res.concat([groupedByCategoryAndLevel]);
        //         }
        //     }
        //     res = res.concat(response.data.history.filter((value) => value.group === null));
        // }
        // response.data.groupedHistory = res;
        // console.log(response.data, 'resp data')
        console.log(response.data, 'response data')
        return response.data;
    }

    public async Professions(): Promise<APIProfession[]> {
        const response = await this.ExecuteRoute<null, APIProfession[]>({
            route: '/user/professions',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async restartGame(): Promise<void> {
        const response = await this.ExecuteRoute<null, void>({
            route: '/user/delete',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async getFinalSum(): Promise<any> {
        const response = await this.ExecuteRoute<null, any>({
            route: '/user/progress',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async GameData(): Promise<APIGameData> {
        const response = await this.ExecuteRoute<null, APIGameData>({
            route: '/game/data',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public Logout() {
        sessionStorage.clear();
        this.SetLoginState('not_logged_in');
        this.user = null;
    }

    public async ResendConfirmEmail(request: {email: string}): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/auth/resend-confirm-mail',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async DoScam(request: {amount: number}): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/user/scam',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async Transaction(request: {to: 'nsj' | 'deposit' | 'wallet' | 'moneybox', name: string, value: number, ignore?: number}): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/transaction/do',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async PayMonth(): Promise<{result: number}> {
        const response = await this.ExecuteRoute<null, {result: number}>({
            route: '/user/month',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        });
        if (response instanceof APIError) {
            throw response;
        }
        return response.data;
    }

    public async SendSms(request: any): Promise<any> {
        const response = await this.ExecuteRoute<typeof request, {token: string}>({
            route: '/auth/sms',
            method: 'POST',
            secure: false,

            contentType: 'application/json',
        }, request);

        if (response instanceof APIError) {
            return response;
        } else {
            this.SetToken(response.data.token);
            this.SetLoginState('logged_in');
        }

        return response
    }

    public async CancelFinance(request: {productKey: string}): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/finance/cancel',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
    }

    public async UseFinance(request: {productKey: string}): Promise<void> {
        const response = await this.ExecuteRoute<typeof request>({
            route: '/finance/use',
            method: 'POST',
            secure: true,
            contentType: 'application/json',
        }, request);
        if (response instanceof APIError) {
            throw response;
        }
    }
}

const APIInstance = new SberAPI({
    baseUri: '/fingram-game',
    // baseUri: 'http://localhost:8009',
    tokenCacheKey: 'API_TOKEN',
});
export default APIInstance;
